import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SettingsService } from 'app/services/core/settings.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: [
    `
      .mat-raised-button {
        margin-right: 8px;
        margin-top: 8px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HomeComponent{
  constructor( public settings: SettingsService ) {}
}
